import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/** Resolve possibly-relative /api/files URLs to absolute for <img src>. */
export function resolveMediaUrl(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${BACKEND_URL}${url}`;
}

export const FESTIVAL_META = {
  roskilde: { name: "Roskilde Festival", color: "#FF4500", short: "Roskilde", accent: "orange", glow: "glow-roskilde",
    image: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtdXNpYyUyMGZlc3RpdmFsJTIwY3Jvd2QlMjBvcmFuZ2UlMjBsaWdodGluZ3xlbnwwfHx8fDE3ODc1MTQ3MjF8MA&ixlib=rb-4.1.0&q=85" },
  northside: { name: "NorthSide", color: "#6200EA", short: "NorthSide", accent: "purple", glow: "glow-northside",
    image: "https://images.unsplash.com/photo-1773346563165-f63acbfd06a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHx1cmJhbiUyMG11c2ljJTIwZmVzdGl2YWwlMjBzdGFnZSUyMHB1cnBsZSUyMGxpZ2h0fGVufDB8fHx8MTc4NzUxNDcyMXww&ixlib=rb-4.1.0&q=85" },
  syd_for_solen: { name: "Syd for Solen", color: "#FFD600", short: "Syd for Solen", accent: "yellow", glow: "glow-syd",
    image: "https://images.pexels.com/photos/2681664/pexels-photo-2681664.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  tinderbox: { name: "Tinderbox", color: "#00BFFF", short: "Tinderbox", accent: "sky", glow: "glow-tinderbox",
    image: "https://images.pexels.com/photos/38485787/pexels-photo-38485787.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  smukfest: { name: "Smukfest", color: "#00C853", short: "Smukfest", accent: "green", glow: "glow-smukfest",
    image: "https://images.unsplash.com/photo-1578946956271-e8234ecaaadd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxtdXNpYyUyMGZlc3RpdmFsJTIwZm9yZXN0JTIwZ3JlZW4lMjBsaWdodGluZ3xlbnwwfHx8fDE3ODc1MTQ3MjF8MA&ixlib=rb-4.1.0&q=85" },
};

export const CATEGORY_LABELS = {
  headliner: "Headliner",
  international: "International",
  danish: "Dansk",
  orange_opener: "Orange Scene åbner",
};

export const CATEGORY_POINTS = {
  headliner: 12,
  international: 4,
  danish: 1,
  orange_opener: 10,
};

export function formatCountdown(deadlineIso) {
  const now = new Date();
  const dl = new Date(deadlineIso);
  const diff = dl - now;
  if (diff <= 0) return { locked: true, text: "Predictions er låst" };
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  return { locked: false, days, hours, minutes, text: `${days}d ${hours}t ${minutes}m` };
}
